<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" class="ml-2" dark icon x-small :href="GetGoogleMapsUlr(row)" target="_blank"
                v-bind="attrs" v-on="on">
                <v-icon v-text="isRoute(row) ? 'mdi-map' : 'mdi-map-marker'" />
            </v-btn>
        </template>
        <span> {{ isRoute(row) ? $t('servicesystem.common_objects.commonterms.show_route_on_map') :
            $t('servicesystem.common_objects.commonterms.show_on_map') }}</span>
    </v-tooltip>
</template>


<script>
export default {
    name: 'DrivingIndicator',
    props: {
        row: Object,
    },
    components: {},

    data() {
        return {};
    },

    methods: {
        GetGoogleMapsUlr({ StartLatitude, StartLongitude, StopLatitude, StopLongitude }) {
            if (StopLatitude && StopLongitude) {
                return `https://www.google.com/maps/dir/${StartLatitude},${StartLongitude}/${StopLatitude},${StopLongitude}`;
            } else {
                return `https://www.google.com/maps/dir/${StartLatitude},${StartLongitude}`;
            }
        },

        isRoute({ StartLatitude, StartLongitude, StopLatitude, StopLongitude }) {
            if (StopLatitude && StopLongitude) {
                if (StopLatitude != StartLatitude && StopLongitude != StartLongitude) {
                    return true;
                }
            }
            return false;
        },
    },

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>
